import ScopeConstants from "constants/ScopeConstants"

export const StaticProjectScope = {
    key: ScopeConstants.STATIC_PROJECTS,
    selector: (state) => state.staticProjects,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Project/SearchAny/"
}